import actions from './constants';

export const fetchSystemCohort = (category, code, intl) => ({
  type: actions.FETCH_SYSTEM_COHORT,
  category,
  code,
  intl,
});

export const showSystemCohort = (category, code, result, intl) => ({
  type: actions.SHOW_SYSTEM_COHORT,
  category,
  code,
  result,
  intl,
});

export const showSystemCohortError = (category, code, error) => ({
  type: actions.SHOW_SYSTEM_COHORT_ERROR,
  category,
  code,
  error,
});

export const closeSystemCohort = ({ category, code }) => ({
  type: actions.CLOSE_SYSTEM_COHORT,
  category,
  code,
});
